


































import { Prop, Component, Vue } from 'vue-property-decorator';
import { EBlockWidth, EPricingTableColumn } from '@lib-shared/editor/types/enums';
import {
  IPricingTable,
  IField,
  IMergeValues,
  IPricingTableColumn,
  IPricingTableCurrencySettings,
  IPricingTableRow,
  IPricingTableSection,
  IPricingTableSummaryValues,
} from '@lib-shared/editor/types';
import PricingTablePriceSummary from '@/editor/editor-block-view/components/pricing-table/PricingTablePriceSummary.vue';
import PricingTableColumnHeaders from '@/editor/editor-block-view/components/pricing-table/PricingTableColumnHeaders.vue';
import PricingTableRow from '@/editor/editor-block-view/components/pricing-table/PricingTableRow.vue';

@Component({
  components: {
    PricingTablePriceSummary,
    PricingTableColumnHeaders,
    PricingTableRow,
  },
})
export default class EditorNodePricingTable extends Vue {
  @Prop() node: IPricingTable;
  @Prop() mergeValues: IMergeValues;
  @Prop() allEditorFields: IField[];
  @Prop() allCustomTags: IField[];
  @Prop() blockWidthClass: EBlockWidth;

  get isBlockWidthSmall(): boolean {
    return (
      this.blockWidthClass === EBlockWidth.XXSmall || this.blockWidthClass === EBlockWidth.XSmall
    );
  }

  get fields(): IField[] {
    return this.node?.fields || [];
  }

  get section(): IPricingTableSection {
    return this.node?.pricingTableSections[0];
  }

  get columns(): IPricingTableColumn[] {
    return this.section?.columns;
  }

  get enabledColumns(): IPricingTableColumn[] {
    return this.columns?.filter(
      column =>
        ![
          EPricingTableColumn.Description,
          EPricingTableColumn.Sku,
          EPricingTableColumn.Discount,
          EPricingTableColumn.NetPrice,
        ].includes(column.name as EPricingTableColumn) && column.enabled
    );
  }

  get rowsSortedByColumnOrder(): IPricingTableRow[] {
    return this.section?.rows?.map(row => ({
      ...row,
      values: this.columns.flatMap(column =>
        row.values.find(rowValue => rowValue.columnId === column.id)
      ),
    }));
  }

  get isPreCalculated(): boolean {
    return this.node?.preCalculated;
  }

  get summaryValues(): IPricingTableSummaryValues {
    return this.node?.pricingTableSummaryValues;
  }

  get sectionSummary(): IPricingTableSummaryValues {
    return this.section?.sectionSummary;
  }

  get currencySettings(): IPricingTableCurrencySettings {
    return this.node?.currencySettings;
  }

  get gridTemplateColumns(): string {
    const columnWidths = this.enabledColumns
      ?.filter(column => column.enabled)
      .map(column => column.width);
    const widthString = columnWidths?.join('% ');
    return `grid-template-columns: ${widthString}%;`;
  }
}
